export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_3.b6d2c22b.jpg";